import React from 'react';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

import {styles} from './PreviousHarRank.style';
interface PreviousHarRankProps {
  tt: (key: string, callback?: any) => string;
  item: {
    previousRank?: {
      description?: string;
    };
  };
}

export const PreviousHarRank: React.FC<PreviousHarRankProps> = ({
  tt = withTranslation.ttDefaultProp,
  item,
}) => {
  const previousRankDescription = item?.previousRank?.description ?? '';
  return tt(
    'previousHarRank',
    generateComponentCallback({
      component: (
        <Text testID={Reports.reportPreviousHraRank}>
          <Text style={styles.previousRankLabel}>Previous HRA</Text>{' '}
          {previousRankDescription}
        </Text>
      ),
    }),
  );
};
